import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

const BASE = 'https://us-central1-tarjeta-ad945.cloudfunctions.net';

export default function PublicMonthlyAgreement() {
  const { token } = useParams();
  const [state, setState] = useState({ loading: true, agreement: null, error: '' });
  const [name, setName] = useState('');
  const [accepted, setAccepted] = useState(false);
  const [termsViewed, setTermsViewed] = useState(false);
  const [showTerms, setShowTerms] = useState(false);
  const [sending, setSending] = useState(false);
  const [done, setDone] = useState(false);

  useEffect(() => {
    fetch(`${BASE}/getPublicMonthlyAgreement?token=${encodeURIComponent(token)}`)
      .then(async (response) => {
        const body = await response.json();
        if (!response.ok) throw new Error(body.error);
        setState({ loading: false, agreement: body.data?.agreement || body.agreement, error: '' });
      })
      .catch((error) => setState({ loading: false, agreement: null, error: error.message || 'No se pudo abrir el acuerdo.' }));
  }, [token]);

  const sign = async (event) => {
    event.preventDefault();
    setSending(true);
    try {
      const response = await fetch(`${BASE}/submitPublicMonthlyAgreement`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ token, signedBy: name, accepted }),
      });
      const body = await response.json();
      if (!response.ok) throw new Error(body.error);
      setDone(true);
    } catch (error) {
      setState((current) => ({ ...current, error: error.message || 'No se pudo firmar el acuerdo.' }));
    } finally {
      setSending(false);
    }
  };

  if (state.loading) return <main className="p-10 text-center">Cargando acuerdo…</main>;
  if (state.error && !state.agreement) return <main className="p-10 text-center text-red-700">{state.error}</main>;
  if (done) return <main className="min-h-screen bg-slate-100 p-10 text-center"><section className="mx-auto max-w-lg rounded-2xl bg-white p-8 shadow"><h1 className="text-2xl font-bold text-slate-900">Acuerdo firmado</h1><p className="mt-2 text-slate-600">BBTS y su equipo recibieron la confirmación electrónica.</p></section></main>;

  const service = state.agreement?.serviceSnapshot || {};
  return <main className="min-h-screen bg-slate-100 p-4 md:p-10">
    <section className="mx-auto max-w-2xl rounded-2xl bg-white p-6 shadow md:p-8">
      <p className="text-sm font-bold tracking-wide text-orange-600">BBTS</p>
      <h1 className="mt-1 text-2xl font-bold text-slate-900">Acuerdo mensual pendiente de firma</h1>
      <p className="mt-2 text-slate-600">Revise las cláusulas y condiciones antes de firmar electrónicamente.</p>
      <div className="mt-5 grid gap-3 rounded-xl bg-slate-50 p-4 text-sm sm:grid-cols-2">
        <p><span className="block text-slate-500">Cliente</span><strong>{state.agreement?.recipientName || 'Cliente'}</strong></p>
        <p><span className="block text-slate-500">Mensualidad</span><strong>${Number(service.monthlyAmount || 0).toFixed(2)}</strong></p>
        <p><span className="block text-slate-500">Facturación</span><strong>Día {service.billingDay || '—'} de cada mes</strong></p>
        <p><span className="block text-slate-500">Vigencia</span><strong>{service.effectiveDate || 'Fecha de firma'}</strong></p>
      </div>
      <button type="button" onClick={() => { setTermsViewed(true); setShowTerms(true); }} className="mt-5 w-full rounded-xl border border-orange-300 bg-orange-50 px-4 py-3 font-bold text-orange-800">Ver cláusulas y condiciones del acuerdo</button>
      {termsViewed && <p className="mt-2 text-center text-xs font-medium text-emerald-700">Cláusulas revisadas.</p>}
      <form onSubmit={sign} className="mt-7 border-t border-slate-200 pt-5">
        <label className="block font-semibold text-slate-800">Nombre completo del firmante<input required value={name} onChange={(event) => setName(event.target.value)} className="mt-1 w-full rounded-lg border border-slate-300 p-3 font-normal" /></label>
        <label className="mt-4 flex gap-2 text-sm text-slate-700"><input required checked={accepted} onChange={(event) => setAccepted(event.target.checked)} type="checkbox" />Acepto firmar electrónicamente este acuerdo y confirmo que estoy autorizado(a) para hacerlo.</label>
        <button disabled={sending || !termsViewed} className="mt-5 rounded-lg bg-orange-600 px-5 py-3 font-bold text-white disabled:cursor-not-allowed disabled:opacity-50">{sending ? 'Firmando…' : 'Firmar acuerdo'}</button>
        {!termsViewed && <p className="mt-2 text-xs text-slate-500">Primero abre y revisa las cláusulas y condiciones.</p>}
        {state.error && <p className="mt-3 text-sm text-red-700">{state.error}</p>}
      </form>
    </section>
    {showTerms && <div className="fixed inset-0 z-50 flex items-center justify-center bg-slate-950/60 p-3" role="dialog" aria-modal="true" aria-label="Cláusulas y condiciones"><section className="flex max-h-[92vh] w-full max-w-4xl flex-col overflow-hidden rounded-2xl bg-white shadow-2xl"><div className="flex items-center justify-between border-b p-4"><div><h2 className="font-bold text-slate-900">Cláusulas y condiciones</h2><p className="text-xs text-slate-500">Acuerdo mensual BBTS</p></div><button type="button" onClick={() => setShowTerms(false)} className="rounded-lg border px-3 py-2 text-sm font-bold text-slate-700">Cerrar</button></div><div className="overflow-y-auto p-2 md:p-5"><div dangerouslySetInnerHTML={{ __html: state.agreement?.documentHtml || '' }} /></div><div className="border-t p-4 text-right"><button type="button" onClick={() => setShowTerms(false)} className="rounded-lg bg-orange-600 px-4 py-2 text-sm font-bold text-white">Entendido</button></div></section></div>}
  </main>;
}
